import React from "react";
import img1 from "../../media/images/img-5.jpg";
import img2 from "../../media/images/repair/repairImg.jpg";

const AboutCompany = () => {
  return (
    <section className="about-section" id="about-us">

      <div className="about-container">

        {/* IMAGE SIDE */}

        <div className="about-images">

          <div className="about-img-large">
            <img src={img1} alt="AC Service" />
          </div>

          <div className="about-img-small">
            <img src={img2} alt="AC Repair" />
          </div>

          <div className="about-experience">
            <h3>100000+</h3>
            <span>Services Done</span>
          </div>

        </div>

        {/* CONTENT SIDE */}

        <div className="about-content">

          <span className="about-tag">
            About RepairBuddy
          </span>

          <h2 className="about-title">
            We Are The Most Trusted AC Repair Company
          </h2>

          <p className="about-description">
            RepairBuddy is your trusted partner for fast, affordable, and expert
            AC services across Delhi-NCR. With 10+ years of experience and more
            than 25,000 satisfied customers, we specialize in AC repair,
            servicing, maintenance, AMC and installation.
          </p>

          <div className="about-highlight">
            Don't feel the heat when you have the best air conditioning service.
          </div>

          <a href="#book-now" className="about-btn">
            Book Service Now
          </a>

        </div>

      </div>

    </section>
  );
};

export default AboutCompany;